const styles = {
  editButton: {
    color: "secondary.main",
    fontSize: 16,
    width: 25,
    height: 25,
  },
};

export default styles;
